<template>
  <v-app>
    <BootstrapVueNavbar/>
    <div style="padding-top: 55px; height: 100vh;">
      <b-alert v-if="NOTIFICATION_MESSAGE && !NOTIFICATION_IMAGE"
               :variant="NOTIFICATION_TYPE ? NOTIFICATION_TYPE : 'success'" class="font-weight-bold h5 text-center mb-0"
               show
               dismissible role="alert">
        <span>{{ NOTIFICATION_MESSAGE }}</span>
        <a v-if="NOTIFICATION_LINK" :href="NOTIFICATION_LINK" target="_blank" rel="noopener noreferrer">
          {{ NOTIFICATION_LINK_MESSAGE ? NOTIFICATION_LINK_MESSAGE : 'Learn More!' }}
        </a>
      </b-alert>

      <b-alert v-if="NOTIFICATION_MESSAGE && NOTIFICATION_IMAGE" class="system-header my-0 d-flex bg-white" show
               dismissible role="alert">
        <div class="row">
          <div class='media col-lg-3'>
            <img :src='NOTIFICATION_IMAGE' title="CitSci.org" alt="CitSci.org" class="mr-5 ml-5"
                 style="height: 32px;"></img>
          </div>
          <div class='media-body font-weight-bold h5 align-middle mb-0 mt-2 col-lg-9'>
            <span>{{ NOTIFICATION_MESSAGE }}</span>
            <a v-if="NOTIFICATION_LINK" :href="NOTIFICATION_LINK" target="_blank" rel="noopener noreferrer">
              {{ NOTIFICATION_LINK_MESSAGE ? NOTIFICATION_LINK_MESSAGE : 'Learn More!' }}
            </a>
          </div>
        </div>
      </b-alert>

      <b-alert variant="success" role="alert" show dismissible class="text-center mb-0" v-if="forgotSent"
               id="forgotSent">
        Success! We've sent a message with a password reset link to your email address.<br/> Please
        click the link, enter a new password, and then login.
      </b-alert>
      <b-alert variant="success" role="alert" show dismissible class="text-center mb-0" v-if="passwordUpdated">
        Hooray! Your password has been changed.<br/>Please login using your email and new password.
      </b-alert>
<!--      <b-alert variant="success" role="alert" show dismissible class="text-center mb-0" v-if="newlyActivated">-->
<!--        <b>Congratulations!</b> your account has been verified.-->
<!--        <br>If you registered on our mobile app, please close this browser and return to the app to make observations.-->
<!--      </b-alert>-->
<!--      <b-alert variant="success" role="alert" show dismissible class="text-center mb-0"-->
<!--               v-if="userCreated && !isVerified">-->
<!--        <b>Welcome to CitSci!</b><br> We've sent you an email with a verification link.<br>-->
<!--        <i>Please click the link in the email we sent you to complete your registration.</i>-->
<!--      </b-alert>-->
      <app-header :headerData="headerData" v-if="displayHeaderBanner" :isProjectProfile="isProjectProfile"
                  :isHomepage="isHomepage"/>
      <router-view :key="$route.fullPath" @header-data-evt="getHeaderData" @is-project-profile="getProjectProfileFlag"
                   :isHomepage="isHomepage" @is-homepage="getHomepageFlag"/>
      <BootstrapVueFooter v-if="!$route.meta.hideFooter" :displaySponsors="displaySponsors"/>

    </div>

    <app-feature-coming-soon></app-feature-coming-soon>
    <app-login-message-modal></app-login-message-modal>
    <app-not-member-modal></app-not-member-modal>
    <app-not-verified-modal></app-not-verified-modal>
  </v-app>
</template>

<script type="text/javascript">
import {mapActions, mapGetters} from 'vuex'
import BootstrapVueNavbar from './components/layout/Navbar.vue'
import BootstrapVueFooter from './components/layout/BootstrapVueFooter'

import {
  NOTIFICATION_MESSAGE,
  NOTIFICATION_TYPE,
  NOTIFICATION_LINK,
  NOTIFICATION_LINK_MESSAGE,
  NOTIFICATION_IMAGE,
} from './config/_entrypoint'

export default {
  name: 'app',
  components: {
    BootstrapVueNavbar,
    BootstrapVueFooter
  },
  methods: {
    ...mapActions({
      clearTabTimeout: 'user/auth/clearTabTimeout',
      checkTokenExpiry: 'user/auth/checkTokenExpiry',
      fetchSession: 'user/profile/fetchSession',
      getUnreadNotifications: 'user/notifications/getUnread',
    }),

    getHeaderData: function (value) {
      this.headerData = value
    },

    getProjectProfileFlag(value) {
      this.isProjectProfile = value
    },

    getHomepageFlag(value) {
      this.isHomepage = value
    },

    reset: function () {
      this.headerData = {
        backgroundPath: '',
        headerTitle: '',
        picturePath: '',
        isPrivate: false,
        approveContacts: false,
        members: 0,
        observations: 0,
        locations: 0,
        measurements: 0,
      }
    }
  },

  created(to, from, next) {
    if (this.isAuthenticated) {
      this.fetchSession();
    }
    this.reset()
  },

  computed: {
    ...mapGetters({
      forgotSent: 'user/forgotPassword/sent',
      passwordUpdated: 'user/resetPassword/updated',
      userCreated: 'user/register/created',
      isVerified: 'user/profile/isVerified',
      isAuthenticated: 'user/auth/isAuthenticated',
      isLogout: 'user/auth/isLogout',
      lastNotification: 'user/notifications/lastNotification',
    }),
    displayHeaderBanner() {
      return this.$route.meta.showHeaderBanner
    },

    displayFooter() {
      return !this.$route.meta.showFooter
    },

    displaySponsors() {
      return this.$route.meta.showSponsors
    }
  },

  data() {
    return {
      headerData: {
        backgroundPath: '',
        headerTitle: '',
        picturePath: '',
        isPrivate: false,
        approveContacts: false,
        members: 0,
        observations: 0,
        locations: 0,
        measurements: 0,
      },
      isProjectProfile: false,
      isHomepage: false,
      // newlyActivated: false,
      NOTIFICATION_MESSAGE: NOTIFICATION_MESSAGE,
      NOTIFICATION_TYPE: NOTIFICATION_TYPE,
      NOTIFICATION_LINK: NOTIFICATION_LINK,
      NOTIFICATION_LINK_MESSAGE: NOTIFICATION_LINK_MESSAGE,
      NOTIFICATION_IMAGE: NOTIFICATION_IMAGE,
      lastToastNotificationId: null,
    }
  },

  watch: {
    '$route'(to, from) {
      this.isHomepage = this.$route.meta.isHomepage || false
    },

    lastNotification(newVal) {
      // Toast for new notification
      if (newVal && !newVal.isRead && newVal.id !== this.lastToastNotificationId) {
        this.lastToastNotificationId = newVal.id
        const h = this.$createElement
        const notification = h('div', [
          h('span', newVal.title),
          h('br'),
          h('b-link', {
            props: {to: {name: 'UserNotifications'}},
            class: 'font-weight-bold underline',
          }, 'View all notifications'),
        ])
        this.$bvToast.toast(notification, {
          title: 'New Notification',
          variant: 'info',
          toaster: 'b-toaster-top-right',
          autoHideDelay: 10000,
          solid: true,
        })
      }
    },

    isAppIdle(newVal, oldVal) {
      if (newVal) {
        // console.log('app idle clear timeout: ', newVal)
        this.clearTabTimeout()
      } else {
        // console.log('app active set timeout: ', newVal)
        this.checkTokenExpiry()
        this.getUnreadNotifications()
      }
    },

    isLogout(newVal) {
      // console.log('app.js - isLogout watch: ', newVal)
      if (newVal) {
        // Token refresh failed, user is logged out
        this.$router.push({name: 'Logout'})
      }
    },
  },

  beforeDestroy() {
    this.reset()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff;
}

.container {
  max-width: 1400px;
}

#footer-container {
  padding-top: 0;
  padding-bottom: 0;
}

.footer-image {
  margin-left: 12px;
}

#CreativeCommonsLink {
  color: #22252C;
  font-weight: bold;
}

#CreativeCommonsLink:hover {
  color: #fff;
  font-weight: bold;
  text-decoration: none;
}

// control height universally for all multiselects on web app
.multiselect {
  // width: 200px;
  // min-height: unset;
  //max-height: 33px;
  //min-height: 33px;
  .multiselect__select /*arrow styles*/
  {
    // if select got too much height change those
    padding-top: 12px;
    padding-bottom: 12px;
    height: 100%;
  }

  .multiselect__tags /*input wrapper*/
  {
    background: white;
    width: 100%;
    min-width: unset;
    display: flex;
    align-items: center;
    // *
    //height: 33px;
    //min-height: unset;
    padding-top: 0;
    justify-content: flex-start;
    // *
    padding-left: 12px;

    .multiselect__single,
    .multiselect__placeholder,
    .multiselect__input /*inside input, placeholder and search input */
    {
      background: white;
      margin: 0;
      padding: 0;
    }
  }

  // Note: Controls the style of all instances of vue-multiselect
  .multiselect__option--highlight {
    background: lightgray;
    outline: 1px;
    color: black;
  }

  .multiselect__option--selected {
    background: #F3F3F3;
    color: #35495E;
    font-weight: bold;
  }

  .multiselect__option--selected:after {
    content: attr(data-selected);
    color: black;
    background: inherit;
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background: lightgray;
    color: black;
  }

  .multiselect__option--selected.multiselect__option--highlight:after {
    background: lightgray;
    content: attr(data-deselect);
    color: black;
  }

  &.is-invalid {
    .multiselect__tags {
      border-color: #dc3545 !important;
    }

    .multiselect__tags:focus-within {
      border-color: #dc3545 !important;
    }

    .multiselect__select {
      border-left-color: #dc3545;
    }
  }
}


.card-body {
  .special {
    background-color: #F5F4E8 !important;
  }
}

a {
  color: #00B0F0;
}

a:hover {
  color: #00B0F0;
  text-decoration: underline;
}

p {
  color: grey;
  font-size: 1.4rem;
  line-height: 1.4;
}

.p-up {
  color: grey;
  font-size: 1.6rem;
  line-height: 1.5;
}

.p-down {
  color: grey;
  font-size: 1.2rem;
  line-height: 1.5;
}

p.card-text {
  font-size: 1.2rem;
}

h1 {
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1.75rem;
}

h2 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

h1,
h2 {
  font-weight: normal;
}

.citation-blockquote {
  width: 70%;
  border-left: solid 12px #D9D9D9;
  margin-left: 24px;
  /*margin-right: auto;*/
}

.hangingindent {
  padding-left: 22px;
  text-indent: -22px;
  font-size: 99%;
  color: #6c757d;
}

.message-holder {
  color: #e5001e;
  font-weight: bold;
}

.sr-only {
  position: absolute;
}

.c-pointer {
  cursor: pointer;
}


.v-btn:focus { // delete this css style after removing Bootstrap-Vue
  outline: none;
}

a.MyLink, .MyLink {
  font-size: 13pt;
  line-height: 28px;
  font-weight: normal;
  padding-bottom: 12px;
}

.btn-delete {
  color: #000000 !important;
  background: rgba(217, 83, 79, 0.3);
  border-color: rgba(217, 83, 79, 0.3) !important;

  &:hover {
    color: #ffffff !important;

    .text-red {
      color: #ffffff !important;
    }
  }
}

.show-newline {
  white-space: pre-wrap
}

.flex-none {
  flex: unset !important;
}

#custom-vuetify-style {
  .outlined-textarea-field,
  .outlined-text-field {
    .v-input__prepend-outer {
      color: rgba(0, 0, 0, .87) !important;
    }

    .v-input__control {
      margin: 4px 0;

      .v-input__slot {
        border-width: thin;
        background: rgba(0, 0, 0, .06) !important;

        &:hover {
          border-width: thin !important;
        }
      }

      .v-text-field__details {
        display: none;
      }
    }

    &.error--text {
      .v-text-field__details {
        display: block;
      }
    }
  }

  .outlined-textarea-field .v-input__control .v-input__slot .v-text-field__slot textarea {
    margin-top: 10px;
  }

  .outlined-text-field {
    .v-input__control {
      .v-input__slot {
        min-height: 24px;

        .v-text-field__slot input {
          margin: 0;
          max-height: 34px;
        }
      }
    }
  }

  .not-allowed {
    &.outlined-textarea-field,
    &.outlined-text-field {
      .v-input__control .v-input__slot {
        background: rgba(0, 0, 0, .03) !important;
      }
    }
  }

  .background-transparent .v-input__control .v-input__slot {
    background: transparent !important;
  }
}

.theme--light.v-icon.v-icon--disabled {
  color: rgba(0, 0, 0, .64) !important;
}

body.background-white .theme--light.application {
  background: #fff; /* background: #F5F4E8 */
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-move {
  cursor: move;
}

.form-control:disabled {
  cursor: not-allowed;
}

.btn:disabled {
  cursor: not-allowed;
}

/*.btn .dropdown-toggle .btn-primary*/

.btn.btn-primary.dropdown-toggle {
  background: #00c8f8;
  background-color: #00c8f8;
  color: #fff;
  font-weight: normal;
  border-radius: 6px;
  border: solid 1px #00c8f8;
  cursor: pointer;
  text-decoration: none;
}

.btn.btn-primary {
  background: #00c8f8;
  background-color: #00c8f8;
  color: #fff;
  font-weight: normal;
  border: solid 1px #00c8f8;
  cursor: pointer;
  text-decoration: none;
}

.btn.btn-primary.focus,
.btn.btn-primary:focus {
  color: #fff;
  background-color: #006076;
  border-color: #006076;
  outline: none;
  box-shadow: none;
}

.btn.btn-primary:hover {
  background: #006076; /* 01AAEF 87983F */
  border-color: #006076;
  border: solid 1px #006076;
  outline: none;
  box-shadow: none;
}

.btn.btn-primary.active,
.btn.btn-primary:active {
  color: #fff;
  background-color: #006076;
  border-color: #006076;
  outline: none;
}

.btn.btn-primary.active.focus,
.btn.btn-primary.active:focus,
.btn.btn-primary.active:hover,
.btn.btn-primary:active.focus,
.btn.btn-primary:active:focus,
.btn.btn-primary:active:hover {
  color: #fff;
  background-color: #006076;
  border-color: #006076;
  outline: none;
  box-shadow: none;
}

.btn.btn-secondary a {
  color: #fff;
  text-decoration: none;
}

.alert-tertiary {
  background: #D4EDDA;
  background-color: #D4EDDA;
  border-color: #D4EDDA;
}

.btn.btn-tertiary {
  background: #87983f; /* #1f4b2c CSU Green */
  background-color: #87983F;
  color: #fff;
  font-weight: normal;
  border: solid 1px #87983F;
  cursor: pointer;
  text-decoration: none;
}

.btn.btn-tertiary.focus,
.btn.btn-tertiary:focus {
  color: #fff;
  background-color: #555F28;
  border-color: #555F28;
  outline: none;
  box-shadow: none;
}

.btn.btn-tertiary:hover {
  background: #555F28; /* 00c8f8*/
  border-color: #555F28;
  border: solid 1px #555F28;
  outline: none;
  box-shadow: none;
}

.btn.btn-tertiary.active,
.btn.btn-tertiary:active {
  color: #fff;
  background-color: #555F28;
  border-color: #555F28;
  outline: none;
}

.btn.btn-tertiary.active.focus,
.btn.btn-tertiary.active:focus,
.btn.btn-tertiary.active:hover,
.btn.btn-tertiary:active.focus,
.btn.btn-tertiary:active:focus,
.btn.btn-tertiary:active:hover {
  color: #fff;
  background-color: #555F28;
  border-color: #555F28;
  outline: none;
  box-shadow: none;
}

.btn-green {
  background-color: #87983f;
  color: #fff;
}

.btn-transparent {
  background: rgba(0, 0, 0, 0);

  background-color: transparent;
  color: #fff;
  width: 210px;
  height: 42px !important;
  line-height: 30px;
  font-size: 20px;
  font-weight: normal;
  border-color: #fff;
  border-radius: 6px;
  border: solid 1px #fff;
  padding: 4px 12px;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  margin-right: 12px;

  &:hover {
    background: #87983F;
    border-color: #fff;
    border-radius: 6px;
    border: solid 1px #fff;
  }
}

.btn-blue {
  background: #00c8f8;
  background-color: #00c8f8;
  color: #fff;
  width: 210px;
  height: 42px !important;
  line-height: 30px;
  font-size: 20px;
  font-weight: normal;
  border-color: #fff;
  border: solid 1px #fff;
  padding: 4px 12px;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  margin-right: 12px;

  &:hover {
    background: #87983F;
    border-color: #fff;
    border: solid 1px #fff;
  }
}

.btn-light-blue {
  background-color: #03a9f4 !important;
  border-color: #03a9f4 !important;
}

input.search-box {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #BDBDBD;
  width: 100%;
  padding-bottom: 0;
  padding-top: 11px;

  &::placeholder {
    color: #BDBDBD;
    font-size: 18px;
  }
}

.gray-input {
  background-color: #eeeeee;
  border-color: #929292;
}

.circle-icon {
  margin: 0 auto;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-color: #000;
  font-size: 14px;
  width: 60px;
  height: 60px;
  padding: 12px;
  color: #00B0F0;

  &.lightbulb {
    color: #00AFEC;
    border-color: #00AFEC;
  }

  &.edit {
    color: #93A05A;
    border-color: #93A05A;
  }

  &.chart {
    color: #F97D33;
    border-color: #F97D33;
  }

  &.datashets {
    color: #5A595A;
    border-color: #5A595A;
  }
}

.btn-home-arrow {
  color: #fff;
}

.color-light-blue {
  color: #00b0f0 !important;
}

.color-orange {
  color: #ff8f00 !important;
}

.color-light-green {
  color: #93A05A !important;
}

.color-gray {
  color: #b3b3b3 !important;
}

.color-white {
  color: #FFFFFF !important;
}

.bg-cit-green {
  background-color: #879649;
}

.border-cit-green-light {
  border-color: #C0C99C !important;
}

.table tr {
  /*background-color: #22252C;
  color: #ffffff;*/
  background-color: #ffffff;
}

.avatar {
  border: 2px solid #FFFFFF;
  width: 55px;
  height: 55px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: middle;
  max-width: 100%;
}

.v-content.transparent {
  margin-top: -56px;
}

#header-carousel {
  .carousel-caption {
    padding-top: 68px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }

  img {
    @media screen and (max-width: 750px) {
      transform: scale(1.1);
    }

    @media screen and (max-width: 715px) {
      transform: scale(1.2);
    }

    @media screen and (max-width: 685px) {
      transform: scale(1.3);
    }

    @media screen and (max-width: 656px) {
      transform: scale(1.4);
    }

    @media screen and (max-width: 627px) {
      transform: scale(1.5);
    }

    @media screen and (max-width: 603px) {
      transform: scale(1.6);
    }

    @media screen and (max-width: 581px) {
      transform: scale(1.7);
    }

    @media screen and (max-width: 560px) {
      transform: scale(1.8);
    }

    @media screen and (max-width: 538px) {
      transform: scale(1.9);
    }

    @media screen and (max-width: 522px) {
      transform: scale(2);
    }

  }
}

@media screen and (max-width: 1037px) {
  .HideResponsive {
    display: none;
  }
}

.custom-asterisk-added {
  color: #ff5252;
}

::-webkit-scrollbar {
  width: 12px;
}

/* 2. Style the track (the background of the scrollbar) */
::-webkit-scrollbar-track {
  background: transparent; /* Makes the track background invisible */
  border-radius: 10px;
}

/* 3. Style the thumb (the draggable part of the scrollbar) */
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black */
  border-radius: 10px; /* Fully rounded corners */
  border: 3px solid transparent; /* Creates padding around the thumb */
  background-clip: content-box; /* Ensures the border is transparent and not covered by the background */
}

/* 4. Style the thumb on hover for a nice interactive effect */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.6); /* Darker on hover */
}

.underline {
  text-decoration: underline;
}

.b-toaster.b-toaster-top-right {
  top: 55px;
}

</style>
